import { useModal } from "@/hooks";
import { Button } from "@/components/Buttons/index";
import modalStyles from "@/styles/Modal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function IdcCooperationSignUpModal(_ref) {
  let {
    onClickHandle
  } = _ref;
  const {
    hideModal
  } = useModal();
  return /*#__PURE__*/_jsxs("div", {
    className: modalStyles.signup,
    children: [/*#__PURE__*/_jsx("p", {
      className: modalStyles.text,
      children: "\u91CD\u8981"
    }), /*#__PURE__*/_jsx("p", {
      className: modalStyles.text,
      children: "\u3059\u3067\u306BSPOOX ID\u3092\u304A\u6301\u3061\u306E\u65B9\u304C\u65B0\u898F\u3067SPOOX\u5229\u7528\u767B\u9332\u3092\u3055\u308C\u307E\u3059\u3068\u3001 \u3054\u5951\u7D04\u4E2D\u306E\u5546\u54C1\u3092\u3054\u8996\u8074\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u306E\u3067\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002"
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      fillMainColor: true,
      large: true,
      onClick: onClickHandle,
      fontBold: true,
      children: "SPOOX\u5229\u7528\u767B\u9332\u3059\u308B"
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      fillColor: true,
      large: true,
      fillGray: true,
      fontBold: true,
      style: {
        marginTop: "14px"
      },
      onClick: hideModal,
      children: "\u623B\u308B"
    })]
  });
}